import React from 'react';
import PropTypes from 'prop-types';
import { CDN_URL } from '../../constants';
import { ArrowRightCircle } from '../Icons';

const EventSlide = ({
  description,
  handlePrevious,
  handleNext,
  handleNextSection,
  isLastSlide,
  thumbnail,
  title,
}) => {
  if (!title) {
    return null;
  }

  return (
    <div className='event-slide'>
      <div className='event-slide__container'>
        {thumbnail && (
          <div
            className='event-slide__image'
            style={{ backgroundImage: `url(${CDN_URL}${thumbnail})` }}
          />
        )}
        <div className='event-slide__content'>
          {title && <div className='event-slide__title'>{title}</div>}
          {description && (
            <div
              className='event-slide__description'
              dangerouslySetInnerHTML={{ __html: description }}
            />
          )}
        </div>
        <div className='event-slide__controls'>
          <button className='event-slide__cta event-slide__cta-previous' onClick={handlePrevious}>
            <ArrowRightCircle className='event-slide__cta-icon' />
          </button>
          {!isLastSlide && (
            <button className='event-slide__cta event-slide__cta-next' onClick={handleNext}>
              <ArrowRightCircle className='event-slide__cta-icon' />
            </button>
          )}
          {isLastSlide && (
            <button className='event-slide__cta-blue' onClick={handleNextSection}>
              <span className='event-slide__cta-blue-title'>Next Section</span>
              <ArrowRightCircle className='event-slide__cta-blue-icon' />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

EventSlide.propTypes = {
  description: PropTypes.string,
  handlePrevious: PropTypes.func,
  handleNext: PropTypes.func,
  handleNextSection: PropTypes.func,
  isLastSlide: PropTypes.bool,
  thumbnail: PropTypes.string,
  title: PropTypes.string,
};

export default EventSlide;
